import React from 'react';
import { createMuiTheme } from '@material-ui/core';
import { plPL } from '@material-ui/core/locale';

const muiTheme = createMuiTheme(
  {
    palette: {
      primary: {
        main: '#73BE28',
        light: '#a7f15c',
        dark: '#3F8E00',
        contrastText: '#FFF',
        disabled: 'rgba(0, 0, 0, 0.23)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.9)',
        secondary: 'rgba(0, 0, 0, 0.65)',
        disabled: 'rgba(0, 0, 0, 0.38)',
      },
      action: {
        active: '#73BE28',
        hover: 'rgba(115, 190, 40, 0.08)',
        selected: '#73BE28',
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        focus: 'rgba(0, 0, 0, 0.12)',
      },
      error: {
        main: '#f44336',
        light: '#e57373',
        dark: '#d32f2f',
        contrastText: '#ffffff',
        hover: 'rgba(245, 0, 87, 0.04)',
      },
      warning: {
        main: '#ff9800',
        light: '#ffb74d',
        dark: '#f57c00',
        contrastText: 'rgba(0, 0, 0, 0.87)',
      },
      info: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4caf50',
        hover: 'rgba(76, 175, 80, .1)',
        light: '#81c784',
        dark: '#388e3c',
        contrastText: 'rgba(0, 0, 0, 0.87)',
        hoverLight: 'rgba(0, 105, 180, 0.04)',
      },
      background: {
        default: 'rgba(245, 245, 245)',
      },
      icon: {
        primary: '#FFF',
        secondary: '#000',
      },
      opinionStatus: {
        success: 'rgba(76,175,80,1)',
        failed: '#f50057',
      },
      menu: {
        primary: '#006600',
        secondary: '#45A923',
      },
      input: {
        disabled: 'rgba(0, 0, 0, .04)',
      },
      status: {
        accepted: '#edf7ed',
        rejected: '#fceceb',
      },
      statusLabel: {
        main: '#0069B4',
        light: '#3A89C1',
        dark: '#004C82',
        contrastText: '#FFFFFF',
        disabled: 'rgba(0, 0, 0, 0.23)',
      },
    },
    overrides: {
      MuiDropzoneArea: {
        root: {
          minHeight: 80,
          backgroundColor: '#F5F5F5',
          border: '2px dashed rgba(0, 0, 0, 0.23)',
        },
        textContainer: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'row-reverse',
        },
        text: {
          fontSize: 16,
          fontWeight: 400,
          color: 'rgba(0, 0, 0, 0.65)',
          marginLeft: 16,
        },
        icon: {
          color: 'rgba(0, 0, 0, 0.38)',
        },
      },
      MuiMenuItem: {
        root: {
          '&.Mui-selected': {
            color: '#fff',
          },
        },
      },
    },
  },
  plPL,
);

const theme = () => muiTheme;

export default theme;
